/*
------------------------------------------------------------------------------------
重複防止ランダム数生成関数
------------------------------------------------------------------------------------
【使用方法】
「random(number, number, bool)」の形式にて関数実行 
第一引数は抽出範囲数（num）、第二引数は最大範囲数（num）、第三引数は1からの戻り値（bool）になります
任意の範囲数から特定の範囲内での重複しない乱数を配列として返します

【サンプルコード】
------------------------------------------------------------------------------------
var result = getRandom(4, 10, true); // 1から始まる4/10の乱数
console.log(result);
------------------------------------------------------------------------------------
*/

function getRandom(minRange, maxRange, zeroBool) { // 引数：抽出数、最大数、1からの戻り値
	var resultAry = [];
	for (var i = 0; i < minRange; i++) {
		if (resultAry.length < minRange) {
			var selRdm = (zeroBool === true)? (Math.ceil(Math.random()*maxRange)) : (Math.floor(Math.random()*maxRange));
			for (var j = 0; j < resultAry.length; j++) {
				if (resultAry[j] === selRdm) {
					j = -1;
					selRdm = (zeroBool === true)? (Math.ceil(Math.random()*maxRange)) : (Math.floor(Math.random()*maxRange));
				}
			}
			resultAry.push(selRdm);
		}
	}
	return resultAry;
}
export default {getRandom}